export class IconGalleryPaginated{
    page:number = 1;
    pageSize:number = 25;
    iconPackId!:string
    packName!:string
    categoryName!:string

}


export class CategoryPackRequestModel{
  page:number = 1;
  pageSize:number = 25;
  categoryName!:string;
  licenseType!:string;
  preference!:string;
  color!:string;
}